<template>
  <div class="user-message-container">
    <div
      v-if="isMobile"
      class="back-menu mobile-position-fixed"
    >
      <mobile-back-menu
        :title="messageSample ? (messageSample.otherUser ? messageSample.otherUser.name : '') : ''"
        :to="messagesMenuLink"
      />
    </div>
    <div
      v-if="isMobile && messageSample && messageSample.ad"
      class="user-message-item"
    >
      <div class="iamge">
        <vue-load-image v-if="messageSample.ad.file">
          <img
            slot="image"
            class="user"
            :src="messageSample.ad.file.url_view | resizeImage(140, 92)"
            :data-src="messageSample.ad.file.url_view | resizeImage(140, 92)"
          >
          <div
            slot="preloader"
            v-loading="true"
            class="img-loading"
          >
            {{ $t('Loading ....') }}
          </div>
          <div slot="error">
            {{ $t('Network error') }}
          </div>
        </vue-load-image>
        <img
          v-else
          src="../assets/no-image.png"
        >
      </div>
      <div class="about">
        <div class="item-title">
          <h4>{{ messageSample.ad.name }}</h4>
        </div>
        <div
          v-if="messageSample.ad.currency"
          class="price"
        >
          <h3>{{ messageSample.ad.price }} {{ messageSample.ad.currency.code }}</h3>
        </div>
      </div>
    </div>
    <div class="user-message custom-margin">
      <message-box :item="true" />
    </div>
  </div>
</template>

<script>
import { dataGet } from '@fps/vue-toolkit/dist/util';
import { mapState } from 'vuex';
import MessageBox from '../components/AccountSettings/MessageBox';
import MobileBackMenu from '../components/Mobile/MobileBackMenu';

export default {
  components: { MobileBackMenu, MessageBox },
  data() {
    return {
      item: {
        title: 'Used garage door, great condition.',
        price: '199',
      },
    };
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      user: state => state.auth.user,
      messageSample(state) {
        const message = dataGet('temp.messages.list.0', state);
        if (message && this.user) {
          const otherUser = message.user_id === this.user.id ? dataGet('ad.user', message) : message.user;
          if (message && otherUser) {
            return {
              ...message,
              created_by: otherUser.id,
              otherUser,
            };
          }
        }
        return null;
      },
    }),
    messagesMenuLink() {
      return {
        name: 'Messages',
        params: this.$route.params,
      };
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/UserMessage.vue